import { render, staticRenderFns } from "./appointInformation.vue?vue&type=template&id=be64e63c&scoped=true&"
import script from "./appointInformation.vue?vue&type=script&lang=js&"
export * from "./appointInformation.vue?vue&type=script&lang=js&"
import style0 from "./appointInformation.vue?vue&type=style&index=0&id=be64e63c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be64e63c",
  null
  
)

export default component.exports